import Vue from "vue";

Vue.filter("price", function (value) {
  return (value / 100).toFixed(2);
});

Vue.filter("tsFormat", function (value, format) {
  if (value === undefined || value === "") return "";
  return new Date(value * 1000).format(format);
});

Vue.filter("tsFormatLong", function (value) {
  if (value === undefined || value === "") return "";
  return new Date(value * 1000).format("yyyy/MM/dd hh:mm:ss");
});

Vue.filter("ts", function (value) {
  if (value === undefined || value === "") return "";
  return new Date(value * 1000).format("yyyy-MM-dd hh:mm:ss");
});
